<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1">
      <article class="wrapper wrapper-content main-column report-rel">
        <section class="animated fadeInUp trisection-wrap">
          <div class="trisection mx-0 mt-4 horizontal-list" v-for="hierarchy of Object.keys(targetItemRelationhierarchy)" v-bind:key="hierarchy">
            <!-- <b-col class="text-center">
              <div class="flex-box ibox-title bg-white">
                <h3 class="dir-title mg-right">{{ hierarchy }}層</h3>
                <i class="fa fa-angle-double-left"></i>
              </div>
            </b-col> -->
            <div id="rel-base" class="pt-4" v-for="itemKey of Object.keys(targetItemRelationhierarchy[hierarchy])" v-bind:key="itemKey">
              <okr-tree-item
              @onDblClick="bePropagatedByChild"
              @onMouseOver="beOver"
              @onMouseLeave="beLeave"
              @onClick="stuckHilight"
              :item="targetItemRelationhierarchy[hierarchy][itemKey]['content']" 
              :selectedKey="targetItemKey" :itemType="targetItemRelationhierarchy[hierarchy][itemKey]['type']" 
              :hilight="hilights.hasOwnProperty(itemKey)"
              :hilightByKeyresult="hilightRelationsByKeyresult.hasOwnProperty(itemKey)"
              :targetType="targetType"
              :targetItem="targetItem.itemTarget === itemKey ? targetItem.hilightTarget: ''"
              :targetMode="targetMode"
              :itemId="itemKey" 
              :userId="targetItemRelationhierarchy[hierarchy][itemKey]['userId']"
              v-on:set-item="setItem" 
              v-on:open-detail="openDetail" 
              :fromDate="fromDate" 
              :toDate="toDate" 
              :searchType="searchType" />
            </div>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import Report1on1Item from '@/components/Report/Report1on1Item'
// import Datepicker from 'vuejs-datepicker'
import ReportRelationsListOkrItem from '@/components/Report/ReportRelationsListOkrItem'
import ReportRelationsListRelItem from '@/components/Report/ReportRelationsListRelItem'
import OkrTreeItem from '@/components/Manage/OkrTreeItem'
import moment from 'moment'
import Icon from 'vue-awesome'
import Datepicker from 'vuejs-datepicker'
import {i18n, liteMode} from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'ManageOkrTree',
  components: {
    Icon,
    ReportRelationsListOkrItem,
    ReportRelationsListRelItem,
    Datepicker,
    OkrTreeItem
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      open: true,
      href: location.href,
      title: document.title,
      baseUser: '',
      baseItemKey: '',
      baseOkrKey: '',
      relSrc: [],
      relDst: [],
      searchType: 'dueDate',
      searchText: '',
      targetItemId: '',
      targetUserId: '',
      searchOpen: true,
      isManager: false,
      targetMode: false, // hilightを固定する
      targetItemKey: '',
      targetItem: {itemTarget: '', hilightTarget: ''}, // ハイライトtargetがkeyresultの時,itemとtargetを渡す
      hilightRelations: {}, // ex {itemId: {itemId:1,itemId:1...}} //hierarchyで作成されたitemkeyとrelationのくみをここに入れとくじゃないとhilightでkeyresult回す必要が出てくる
      hilightRelationUps: {}, // upとdownで分けたほうがやりやすいことに気づいた
      hilights: {}, // ex {itemId: 1} //hierachyfuncが再起されずにdomの部分だけ変更されたい 何回も実行されるのでO(1)は必須// fromDate: moment().subtract(1, 'month').toDate(),
      targetType: '', // mouseover時のtarget
      hilightRelationsByKeyresult: {}, // targetのkeyresultからのrelationを取得する
      fromDate: moment().toDate(),
      toDate: moment().toDate(), // 絞り込む時にtoDateは現状は指定されていないのでとりあえず999年後にしておく
      format: 'yyyy/MM/dd',
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      }
    }
  },
  props: {
    propUserId: String,
    propItemId: String
  },
  getters: {
  },
  beforeRouteUpdate (to, from, next) {
    // このコンポーネントを描画するルートが変更されたときに呼び出されますが、
    // このコンポーネントは新しいルートで再利用されます。
    // たとえば、動的な引数 `/foo/:id` を持つルートの場合、`/foo/1` と `/foo/2` の間を移動すると、
    // 同じ `Foo` コンポーネントインスタンスが再利用され、そのときにこのフックが呼び出されます。
    // `this` でコンポーネントインスタンスにアクセスできます。
    // okrTree/{$userId}/{$itemId} で取得する予定
    console.log('ManageOkrTree:params', to.params)
    console.log('before:update')
    this.targetItemId = ''
    this.targetUserId = ''
    this.targetItemId = to.params.itemId
    this.targetUserId = to.params.userId
  },
  mounted: function () {
    console.log('checkhierarchy', this.targetItemRelationhierarchy)
  },
  updated: function () {
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'okrTree'
    },
    checkLanguage () {
      return i18n.locale
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByUserId',
      'getKeyresultById'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByIds',
      'getObjectivesByUserId',
      'getObjectiveById'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById'
    ]),
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        // return this.getUsers
        return {}
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getObjs () {
      let userId = this.targetUserId
      if (!userId.length > 0 && this.$route.params.userId) {
        userId = this.$route.params.userId
      }
      return this.getObjectivesByUserId(userId, true, true)
    },
    getKeyresult () {
      let userId = this.targetUserId
      if (!userId.length > 0 && this.$route.params.userId) {
        userId = this.$route.params.userId
      }
      return this.getKeyresultsByUserId(userId, true, true)
    },
    targetItemRelationhierarchy () {
      // 特定のitemに対してrelationで階層を作る
      // keyresultがその親を示している場合も同様に
      console.log('params', this.$route.params)
      let targetId = this.targetItemId
      let targetUserId = this.targetUserId
      if (!(this.targetItemId.length > 0 && this.targetUserId.length > 0) && this.$route.params) {
        targetId = this.$route.params.itemId
        targetUserId = this.$route.params.userId
      }
      const Objs = this.getObjs
      const keyresults = this.getKeyresult
      let targetType = 'obj'
      if (!Objs.hasOwnProperty(targetId)) {
        console.log('hierarchy:check', Objs, Objs[targetId])
        if (!keyresults.hasOwnProperty(targetId)) {
          console.log('hierarchy:check', keyresults, keyresults[targetId])
          // unown
          return targetId
        } else {
          targetType = 'keyresult'
        }
      }
      let stack = []
      let hierarchy = {}
      hierarchy['0'] = {}
      let hierarchyByItem = {} // itemkeyでhierarchyを調べる
      // 現状 hieraruchy[hierarchy][itemId]となっているのを一旦 hieraruchy[userId][itemId]としてhierarchy[itemId]に戻す
      let userHierarchy = {} // 1層(0~n層)以下から見る
      if (targetType === 'obj') {
        hierarchy['0'][targetId] = {content: Objs[targetId], type: 'objectives', userId: targetUserId}
        stack.push({content: Objs[targetId], key: targetId})
        if (Objs[targetId].hasOwnProperty('keyresults')) {
          for (let keyresultKey of Object.keys(Objs[targetId]['keyresults'])) {
            if (keyresults.hasOwnProperty(keyresultKey)) {
              hierarchyByItem[keyresultKey] = 0
              stack.push({content: keyresults[keyresultKey], key: targetId})
            }
          }
        }
      } else {
        hierarchy['0'][targetId] = {content: keyresults[targetId], type: 'keyresults', userId: targetUserId}
        stack.push({content: keyresults[targetId], key: targetId})
      }
      hierarchyByItem[targetId] = 0
      while (stack.length > 0) {
        const stackPop = stack.pop()
        let target = stackPop.content
        let targetHierarchyId = stackPop.key
        if (!this.hilightRelations.hasOwnProperty(targetHierarchyId)) {
          this.hilightRelations[targetHierarchyId] = {}
        }
        if (!hierarchyByItem.hasOwnProperty(stackPop.key)) {
          console.log('stackPop', stackPop)
        }
        if (target.hasOwnProperty('relations')) {
          for (let id of Object.keys(target['relations'])) {
            const relation = target['relations'][id]
            if (!relation.hasOwnProperty('dir') || relation.dir === 'dst' || !relation.userId || hierarchyByItem.hasOwnProperty(relation.key)) {
              // 渡す側は無視する
              // console.log('what', relation)
              continue
            }
            // hilight用
            if (!this.hilightRelationUps.hasOwnProperty(relation.key)) {
              this.hilightRelationUps[relation.key] = {}
            }
            this.hilightRelations[targetHierarchyId][relation.key] = 1
            this.hilightRelationUps[relation.key][targetHierarchyId] = 1
            let key = relation.key
            if (relation.type === 'keyresults') {
              let targetKeyresults = this.getKeyresultsByUserId(relation.userId, true, true)
              if (!targetKeyresults.hasOwnProperty(key)) {
                console.log('what', key)
              }
              stack.push({content: targetKeyresults[key], key: key})
              hierarchyByItem[key] = hierarchyByItem[targetHierarchyId] + 1
              if (!userHierarchy.hasOwnProperty(hierarchyByItem[key])) {
                // hierarchy[hierarchyByItem[key]] = {}
                userHierarchy[hierarchyByItem[key]] = {}
              }
              if (!userHierarchy.hasOwnProperty(relation.userId)) {
                userHierarchy[hierarchyByItem[key]][relation.userId] = {}
              }
              // hierarchy[hierarchyByItem[key]][key] = {content: targetKeyresults[key], type: relation.type, userId: relation.userId}
              userHierarchy[hierarchyByItem[key]][relation.userId][key] = {content: targetKeyresults[key], type: relation.type, userId: relation.userId}
            } else {
              // obj
              let obj = this.getObjectivesByUserId(relation.userId, true, true)[key]
              stack.push({content: obj, key: key})
              hierarchyByItem[key] = hierarchyByItem[targetHierarchyId] + 1
              if (!userHierarchy.hasOwnProperty(hierarchyByItem[key])) {
                // 被りは無くしたいのでobjで
                // hierarchy[hierarchyByItem[key]] = {}
                userHierarchy[hierarchyByItem[key]] = {}
              }
              if (!userHierarchy.hasOwnProperty(relation.userId)) {
                userHierarchy[hierarchyByItem[key]][relation.userId] = {}
              }
              // hierarchy[hierarchyByItem[key]][key] = {content: obj, type: relation.type, userId: relation.userId}
              userHierarchy[hierarchyByItem[key]][relation.userId][key] = {content: obj, type: relation.type, userId: relation.userId}
              if (obj.hasOwnProperty('keyresults')) {
                let targetKeyresults = this.getKeyresultsByUserId(relation.userId, true, true)
                for (let keyresultKey of Object.keys(obj['keyresults'])) {
                  if (targetKeyresults.hasOwnProperty(keyresultKey)) {
                    hierarchyByItem[keyresultKey] = hierarchyByItem[targetHierarchyId] + 1
                    stack.push({content: targetKeyresults[keyresultKey], key: key})
                  }
                }
              }
            }
          }
        }
      }
      // userHierarchyをhierarchyにする
      // これすることで、userごとにまとまりを作る
      for (let hier of Object.keys(userHierarchy)) {
        hierarchy[hier] = {}
        for (let userId of Object.keys(userHierarchy[hier])) {
          for (let key of Object.keys(userHierarchy[hier][userId])) {
            hierarchy[hier][key] = userHierarchy[hier][userId][key]
          }
        }
      }
      console.log('hierarchy', this.targetItemId, hierarchy, hierarchyByItem, userHierarchy)
      return hierarchy
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    targetUserInfo () {
      return {
        userName: '（ユーザ名取得中）',
        userIcon: null,
        ...this.getUserInfoById(this.targetUser)
      }
    }
  },
  created () {
    // this.$root.$on('bv::scrollspy::activate', this.onActivate)
  },
  watch: {
    searchType () {
      console.log('watch:searchType', this.searchType)
    },
    targetItemId () {
      console.log('this.targetItemId', this.targetItemId)
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    openPickerFrom: function () {
      this.$refs.programaticOpenFrom.showCalendar()
    },
    getHilightInfo: function (key) {
      if (this.hilightInfos.hasOwnProperty(key)) {
        return this.hilightInfos[key]
      } else {
        // keyresultなら情報登録されてないとおかしい
        return {target: 'Objective', targetId: key}
      }
    },
    getHilight: function (key) {
      console.log('gethilight', this.hilights)
      return this.hilights.hasOwnProperty(key)
    },
    openPickerTo: function () {
      this.$refs.programaticOpenTo.showCalendar()
    },
    bePropagatedByChild: function (data) {
      // どうやら、paramsの変更では、urlの検知がされないので(表示上は変わるが、historyとurlは変更されない？)
      // promiseに一度root(okrTree)に戻して、目的のところに行くものを作る
      let promise = []
      console.log('data', data, this.$router)
      console.log('data:check', !(data.userId === this.targetUserId && data.itemId === this.targetItemId), this.targetUserId, this.targetItemId)
      promise.push(this.$router.push({path: '/okrTree/'}))
      promise.push(this.$router.replace({path: '/okrTree/' + data.userId + '/' + data.itemId + '', params: {userId: data.userId, itemId: data.itemId}}))
      // うまいことここら辺がレンダリングで更新されないので、さらにrouter変更時にpushする
      promise.push(this.targetItemId = data.itemId)
      promise.push(this.targetUserId = data.userId)
      Promise.all(promise)
    },
    stuckHilight: function (data) {
      this.targetMode = !this.targetMode
      if (!this.targetMode) {
        this.hilights = {}
        this.hilightRelationsByKeyresult = {}
        this.targetItem = {itemTarget: '', hilightTarget: ''}
      }
    },
    beOver: function (data) {
      if (this.targetMode) {
        return
      }
      // targetとtargetIdが来る
      const targetId = data.targetId
      const target = data.target
      const itemId = data.itemId
      this.targetType = target
      const ups = this.hilightRelationUps
      const downs = this.hilightRelations
      if (target === 'keyresults') {
        this.targetItem.itemTarget = itemId
        this.targetItem.hilightTarget = targetId
        // kr->krの組みのみを取ってくる
        // krの組みから上,下はobj同様のup,downに当てはめれるように
        const keyresults = this.getKeyresultsByUserId(data.userId, true, true)
        const item = keyresults[targetId]
        let upQueue = []
        let downQueue = []
        if (item.hasOwnProperty('relations')) {
          // console.log('set', item)
          for (let relationKey of Object.keys(item['relations'])) {
            const key = item['relations'][relationKey].key
            const type = item['relations'][relationKey].type
            // keyResultItems[key] = type
            if (item['relations'][relationKey].dir === 'dst') {
              upQueue.push(key)
              if (type === 'keyresults') {
                upQueue.push(keyresults[key].parentObjId)
              }
            } else {
              downQueue.push(key)
              if (type === 'keyresults') {
                downQueue.push(keyresults[key].parentObjId)
              }
            }
          }
        }
        while (upQueue.length > 0) {
          let que = upQueue.shift()
          if (this.hilights.hasOwnProperty(que)) {
            continue
          }
          this.$set(this.hilights, que, true)
          if (ups.hasOwnProperty(que)) {
            upQueue = upQueue.concat(Object.keys(ups[que] || {}))
          }
        }
        while (downQueue.length > 0) {
          let que = downQueue.shift()
          if (this.hilights.hasOwnProperty(que)) {
            continue
          }
          this.$set(this.hilights, que, true)
          if (downs.hasOwnProperty(que)) {
            downQueue = downQueue.concat(Object.keys(downs[que] || {}))
          }
        }
        // console.log('data', this.hilightRelationsByKeyresult, keyresults)
      } else {
        if (this.hilights.hasOwnProperty(itemId)) {
          return
        }
        this.hilights = {}
        let queue = []
        this.$set(this.hilights, itemId, true) // 自分自身
        // queueの要素はquery = {dir: dst or src, itemId: itemId} とする
        queue = Object.keys(ups[itemId] || {})
        while (queue.length > 0) {
          // 幅優先探索で行う
          // 方向が割り振られているものに向かって追加していく
          let que = queue.shift()
          if (this.hilights.hasOwnProperty(que)) {
            // （グラフで考えた時に）経路探索してる最中に二回以上頂点を訪れるとそこはループします
            // ぶつぎりすることでその問題が解消されたらいいなと思いますが、ループバグがあれば別途考える
            continue
          }
          this.$set(this.hilights, que, true)
          if (ups.hasOwnProperty(que)) {
            queue = queue.concat(Object.keys(ups[que] || {}))
          }
        }
        console.log('check', this.hilights)
        queue = Object.keys(downs[itemId] || {})
        while (queue.length > 0) {
          let que = queue.shift()
          if (this.hilights.hasOwnProperty(que)) {
            continue
          }
          this.$set(this.hilights, que, true)
          if (downs.hasOwnProperty(que)) {
            queue = queue.concat(Object.keys(downs[que] || {}))
          }
        }
      }
      // if(item.hasOwnProperty('keyresults')) {
      // }
      // this.hilights = Object.assign(this.hilights, target)
    },
    beLeave: function (data) {
      if (this.targetMode) {
        return
      }
      this.hilights = {}
      this.hilightRelationsByKeyresult = {}
      this.targetItem = {itemTarget: '', hilightTarget: ''}
    },
    isBetweenDate (item) {
      if (!item || !Object.keys(item).length) { return false }
      let dueDate = moment(item.dueDate || 0).format('YYYYMMDD')
      let startDate = item.startDate ? moment(item.startDate || 0).format('YYYYMMDD') : moment(item.dueDate || 0).format('YYYYMMDD')
      let fromDate = moment(this.fromDate).format('YYYYMMDD')
      let toDate = moment(this.toDate).format('YYYYMMDD')
      switch (this.searchType) {
        case 'dueDate':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? dueDate <= toDate : true)
        case 'startDate':
          return (this.fromDate ? startDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
        case 'active':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
      }
    },
    setItem (val) {
      console.log('setItem: ', val)
      this.targetItemKey = val.itemId
      this.targetOkrKey = val.parentObjId || val.itemId
      console.log('setItem: ', this.targetItemKey, this.targetOkrKey)
    },
    setTarget (val, ev) {
      console.log('setTarget: ', val, ev)
      this.setUserKey(val.userId)
      this.setItem(val)
      console.log('setTarget: ', this.targetUser, this.targetItemKey, this.targetOkrKey)
    },
    onClickBack () {
      this.open = false
      this.searchOpen = true
    },
    setUserKey (userKey) {
      this.targetUser = userKey
      this.open = true
      this.searchOpen = false
      if (this.getUserId !== userKey) { this.setVisit(userKey) }
    },
    setUserMe () {
      this.setUserKey(this.getUserId)
      // this.setUserKey(this.$store.getters.getCurrentUserId)
    },
    openDetail: function (value) {
      this.$router.push({ name: 'User', params: { userId: value.userId || this.targetUser, item: value.type } })
    },
    clearDate: function (type) {
      if (type === 'from') {
        this.fromDate = ''
      } else {
        this.toDate = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h4.date-label {
  font-size: 150%;
}
.input-searchType {
  margin: auto 0;
  display: -webkit-inline-box;
  padding-inline-start:1px;
  li:not(:first-child) {
    margin-left: 35px;
  }
  input[type="radio"]~label {
    margin-left: 5px;
  }
}
.search-calendar {
  display: inline-block;
  padding-inline-start:18px;
}
.select-date {
  display: flex;
  margin: auto 0;
}
.report-rel {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.back-btn {
  height: 2.5em;
}
.trisection-wrap {
  // height: calc(100% - 23.5em);
}
.trisection-head {
  height: 5em;
}
.trisection {
  // height: calc(100% - 7.5em);
  &>div {
    // height: calc(72vh);
    height: 100%;
    word-wrap: break-word;
  }
}
.selected {
  .okrItem {
    opacity: .5;
  }
  .target {
    box-shadow: 0 0 .1em .2em #ffcccc;
    .okrItem {
      opacity: 1;
    }
  }
}
.dir-title {
  height: 100%;
  max-height: 6.8rem;
  border: none;
  color: #3e8fe0;
  line-height: 4rem;
}
.trisection-head .flex-box {
  width: 100%;
  align-items: center;
}
.mg-right {
    margin-right: 2rem;
    margin-left: 1rem;
}
.fa-angle-double-left {
  font-size: 1.7em;
  // vertical-align: middle;
}
.bg-info {
      font-size: 12.5px;
      width: 475px;
}
.horizontal-list {
  overflow-x: scroll;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.pt-4 {
  display: inline-flex;
  padding-left: 30px;
  padding-right: 30px;
}
.hilight {
   outline-width: 10px;
   outline-style: solid;
   outline-color: skyblue;
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageOkrTree.vue